"use client";

import type { ReactNode } from "react";
import type { LeadFormLocation, LeadFormName } from "@/lib/data-layer";

export function CallbackCtaButton({
  className,
  children,
  ariaLabel,
  formName = "enquiry",
  formLocation,
}: {
  className: string;
  children: ReactNode;
  ariaLabel?: string;
  formName?: LeadFormName;
  formLocation?: LeadFormLocation;
}) {
  return (
    <button
      type="button"
      className={className}
      aria-label={ariaLabel}
      data-gtm="enquiry-open"
      onClick={() => {
        window.dispatchEvent(
          new CustomEvent("isell:open-callback", {
            detail: { formName, formLocation },
          }),
        );
      }}
    >
      {children}
    </button>
  );
}
